exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "empty{display:flex;padding:100px;justify-content:center}empty h3{color:#aaa}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/utility/empty/empty.styl
 ** module id = 256
 ** module chunks = 0
 **/